import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import OnlineLanding from "@/pages/OnlineLanding";
import ThankYou from "@/pages/ThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function AdminGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 text-emerald-600">
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }
  return user ? <AdminDashboard /> : <AdminLogin />;
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App noise-overlay">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141B18",
            border: "1px solid #22302A",
            color: "#F5F7F5",
          },
        }}
      />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/online" element={<OnlineLanding />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminGate />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
